import React from 'react';
import { Box, costFormater, List } from '@common-fe/common-fe';

import { FundsHistoryTransaction } from '../../UnappliedFunds.types';

const formatAmount = (amount: number) => costFormater(amount, true).replace('-', '−');

const FundsHistoryItem: React.FC<FundsHistoryTransaction> = ({ id, amount, date, description }) => (
  <List.Item testId={`funds-history_item_${id}`} disableHover>
    <Box direction="row" align="center" fill>
      <List.Item.Text flex={2} testId={`funds-history_item_${id}_amount`} weight="bold">
        {formatAmount(amount)}
      </List.Item.Text>
      <List.Item.Text flex={2} testId={`funds-history_item_${id}_date`} weight={400}>
        {date}
      </List.Item.Text>
      <List.Item.Text flex={4} testId={`funds-history_item_${id}_description`} weight={400}>
        {description}
      </List.Item.Text>
    </Box>
  </List.Item>
);

export default FundsHistoryItem;
